// Modules
import React from 'react';

// Material-UI
import Drawer from 'material-ui/Drawer';
import List, {
  ListItem,
  ListItemIcon,
  ListItemText,
} from 'material-ui/List';
import Hidden from 'material-ui/Hidden';
import Divider from 'material-ui/Divider';
import DashboardIcon from 'material-ui-icons/Map';
import PinIcon from 'material-ui-icons/Place';
import SignOutIcon from 'material-ui-icons/PowerSettingsNew';

// Styles
import './style.css';

export default class extends React.Component {
  handleNavigate = (page) => {
    this.props.handleDrawerToggle();
    setTimeout(() => {
      this.props.history.push(page);
    }, 300);
  }

  render() {
    const drawer = (
      <div className="drawer">
        <Divider />
        <List>
          <ListItem className="drawer-header">
            <img
              src="./img/png/Logo.png"
              alt="Aspect Engineering Logo"
              style={{ maxWidth: '100%', marginBottom: 24 }}
            />
            <span className="version-number">
              v1.0.0-alpha.1
            </span>
          </ListItem>
        </List>
        <Divider />
        <List>
          <ListItem button onClick={() => this.handleNavigate('dashboard')}>
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItem>
          <ListItem button onClick={() => this.handleNavigate('pins')}>
            <ListItemIcon>
              <PinIcon />
            </ListItemIcon>
            <ListItemText primary="Pins" />
          </ListItem>
          <ListItem button onClick={this.props.handleSignOut}>
            <ListItemIcon>
              <SignOutIcon />
            </ListItemIcon>
            <ListItemText primary="Sign Out" />
          </ListItem>
        </List>
      </div>
    );

    return (
      <div>
        <Hidden mdUp>
          <Drawer
            type="temporary"
            open={this.props.mobileOpen}
            onClose={this.props.handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="css">
          <Drawer
            type="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ResponsiveDrawer/index.js